import { DateTime, Settings } from "luxon";
Settings.defaultLocale = "de-CH";
app.crypto = {};
app.verarbeiteKeys = async function (key, index) {
  try {
    if (!app.crypto.keys) {
      app.crypto.keys = {};
    }
    app.crypto.keys[index] = await importRsaPublicKey(JSON.parse(key));
  } catch (e) {
    throw new Error("app.verarbeiteKeys fehlgeschlagen: ", e);
  }
};

app.verarbeitePrivateKey = async function (key, index) {
  try {
    app.crypto.keyPrivate = {
      index,
      key: await importRsaPrivateKey(JSON.parse(key))
    };
    return app.crypto.keyPrivate; // damit await funktioniert
  } catch (e) {
    console.error("app.verarbeitePrivateKey fehlgeschlagen", e.message, e);
    app.saveToLog("app.verarbeitePrivateKey fehlgeschlagen", e.message, ERROR);
  }
  return null;
};

/**	Sucht Schlüssel im localStorage und fragt sonst Benutzer
 * 		Ausser wenn newKey = true, dann wird zwingend gefragt
 */
app.getDecryptKey = async function (newKey) {
  const activeKeyIndex = app.data.settings.key_in_use_private.value;

  // Buttons zum Key anfordern wieder verstecken
  $("#missionDetail").find(".force-get-decrypt-key").addClass("hide");

  // Nutze foundationNotify-Plugin um nach Key zu fragen
  function frageNachKey(callback) {
    let exampleKey = app.data.keys[0].value;

    fnotify.prompt(
      function (button, answer) {
        if (button == "success") {
          setTimeout(function () {
            let missionId = $("#missionDetail").data("missionId");
            $("#missionDetail").foundation("close");
            $(`tr[data-mission-id=${missionId}]`).trigger("click", [true]);
          }, 300);

          callback(answer);
        }
      },
      "Privater Schlüssel",
      "Bitte den privaten Schlüssel für " + activeKeyIndex + " eingeben",
      { success: "OK", alert: "Abbrechen" },
      exampleKey,
      "small"
    );
  }
  // Key laden
  let privKey = localStorage.getItem(activeKeyIndex);

  // Falls Key nicht gut oder nicht im localStorage war
  if (String(privKey).length < 40 || newKey === true) {
    frageNachKey(function (enteredKey) {
      if (String(enteredKey).length > 40) {
        privKey = enteredKey;
        // Speicher neuen Schlüssel
        localStorage.setItem(activeKeyIndex, privKey);
        // Aktiviere neuen Schlüssel
        let verarbeiteterKey = app.verarbeitePrivateKey(
          privKey,
          activeKeyIndex
        );
        if (verarbeiteterKey) {
          return verarbeiteterKey;
        }
      }
      fnotify.alert(
        "Fehler!",
        `Der eingegebene Schlüssel war ungültig. Bitte den privaten Schlüssel für ${activeKeyIndex}, den du auf eurer Team-Dateiablage findest, als Text einfügen. Du kannst die Datei einfach aus dem Explorer auf das Textfeld ziehen.`,
        "Verstanden! Weiter zum 2. Versuch",
        function () {
          frageNachKey(function (enteredKey2) {
            if (String(enteredKey2).length > 40) {
              privKey = enteredKey2;
              // Speicher neuen Schlüssel
              localStorage.setItem(activeKeyIndex, privKey);
              // Aktiviere neuen Schlüssel
              let verarbeiteterKey = app.verarbeitePrivateKey(
                privKey,
                activeKeyIndex
              );
              if (verarbeiteterKey) {
                return verarbeiteterKey;
              }
            }
            app.saveToLog(
              "app.getDecryptKey",
              `Schlüssel ${activeKeyIndex} 2x falsch eingegeben! Du wirst abgemeldet.`,
              WARNING
            );

            fnotify.alert(
              "Fehler!",
              `Schlüssel ${activeKeyIndex} 2x falsch eingegeben! Du wirst abgemeldet.`,
              "Verstanden",
              function () {
                $.ajax({
                  type: "GET",
                  url: app.urls + "/logout", //nicht app.backend!
                  dataType: "json"
                }).always(function () {
                  window.location.href = app.urls;
                });
              }
            );
          });
        }
      );
    });
  } else {
    // Aktiviere neuen Schlüssel
    return app.verarbeitePrivateKey(privKey, activeKeyIndex);
  }
  // Ende Falls Key nicht gut oder nicht im localStorage war
};
// Ende Sucht Schlüssel im localStorage

function importRsaPublicKey(jsonKey) {
  return window.crypto.subtle.importKey(
    "jwk",
    jsonKey,
    {
      name: "RSA-OAEP",
      hash: { name: "SHA-512" }
    },
    false,
    ["encrypt"]
  );
}

function importRsaPrivateKey(jsonKey) {
  return window.crypto.subtle.importKey(
    "jwk",
    jsonKey,
    {
      name: "RSA-OAEP",
      hash: { name: "SHA-512" }
    },
    false,
    ["decrypt"]
  );
}

async function encryptMessage(message, publicKey) {
  let enc = new TextEncoder();
  let encoded = enc.encode(JSON.stringify(message));

  return window.crypto.subtle.encrypt(
    {
      name: "RSA-OAEP"
    },
    app.crypto.keys[publicKey],
    encoded
  );
}

async function decryptMessage(ciphertext) {
  let decrypted;
  if (!app.crypto.keyPrivate) {
    app.crypto.keyPrivate = await app.getDecryptKey();
  }
  if (app.crypto.keyPrivate?.key) {
    decrypted = await window.crypto.subtle.decrypt(
      {
        name: "RSA-OAEP"
      },
      app.crypto.keyPrivate.key,
      ciphertext
    );
  } else {
    console.error(
      "Der richtige Key scheint nicht vorhanden zu sein. Es wird eine Fehlermeldung mit ReferenceError geben."
    );
  }

  let dec = new TextDecoder();
  return JSON.parse(dec.decode(decrypted));
}

function str2ab(str) {
  const buf = new ArrayBuffer(str.length);
  const bufView = new Uint8Array(buf);
  for (let i = 0, strLen = str.length; i < strLen; i++) {
    bufView[i] = str.charCodeAt(i);
  }
  return buf;
}

function ab2str(buf) {
  return String.fromCharCode.apply(null, new Uint8Array(buf));
}

function downloadFile(data, filename) {
  let element = document.createElement("a");
  element.setAttribute(
    "href",
    "data:application/json;charset=utf-8," + encodeURIComponent(data)
  );
  element.setAttribute("download", filename);

  element.style.display = "none";
  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
}

app.getRandom = function (length) {
  return window.crypto.randomUUID().replace("-", "").substr(0, Number(length));
};

app.encryptPatientenDaten = async function (
  name,
  vorname,
  geburtsdatum,
  keyIndex
) {
  let patient = {
    n: String(name),
    v: String(vorname),
    g: String(geburtsdatum),
    r: app.getRandom(6)
  };
  let encrypted;
  try {
    encrypted = await encryptMessage(patient, keyIndex);
  } catch (error) {
    app.saveToLog(
      "app.encryptPatientenDaten encrypt fehlgeschlagen",
      { error },
      ERROR
    );
  }
  try {
    return window.btoa(ab2str(encrypted));
  } catch (error) {
    app.saveToLog(
      "app.encryptPatientenDaten btoa fehlgeschlagen",
      { error },
      ERROR
    );
    return;
  }
};

app.encryptDiagnose = async function (diagnose, keyIndex) {
  let diagnoseObj = {
    d: String(diagnose),
    r: app.getRandom(6)
  };

  let encrypted;
  try {
    encrypted = await encryptMessage(diagnoseObj, keyIndex);
  } catch (error) {
    app.saveToLog(
      "app.encryptDiagnose encrypt fehlgeschlagen",
      { error },
      ERROR
    );
  }
  try {
    return window.btoa(ab2str(encrypted));
  } catch (error) {
    app.saveToLog("app.encryptDiagnose btoa fehlgeschlagen", { error }, ERROR);
    return;
  }
};

app.decryptData = async function (data) {
  let ciphertext = str2ab(window.atob(data));
  let decrypted = await decryptMessage(ciphertext);

  return decrypted;
};

app.generateKey = async function (oldIndex) {
  if (oldIndex == app.data.settings.key_in_use_private.value) {
    window.alert(
      `Der Key ${oldIndex} ist aktuell als key_in_use_private markiert und kann deshalb nicht überschrieben werden.\n\nAbgebrochen. Es wurde nichts im System verändert.`
    );
    return false;
  }

  let sure = window.confirm(
    `Bist du sicher, dass du den alten Key «${oldIndex}» in der Datenbank überschreiben möchtest?\n\nDieser Vorgang kann nur in der Datenbank rückgängig gemacht werden und betrifft alle anschliessend bearbeiteten Einsätze.`
  );
  let understood;
  let newIndex = `key_${DateTime.local().toFormat(
    "yyyy-MM"
  )}_${app.getRandom(6)}`;

  if (sure) {
    understood = window.confirm(
      `Der neue Key «${newIndex}» wird in die Datenbank gesetzt. Er ist allerdings erst im Hintergrund aktiv, damit laufende Einsätze weiterhin entschlüsselt werden können.\n\nJeder laufende Einsatz muss einmal editiert werden, um die Daten auch mit diesem neuen Key zu schreiben. Erst dann kann «key_in_use_private» auf ${newIndex} gesetzt werden.`
    );
  }

  if (!sure || !understood) {
    window.alert("Abgebrochen. Es wurde nichts im System verändert.");
    return false;
  }

  let key = await window.crypto.subtle.generateKey(
    {
      name: "RSA-OAEP",
      modulusLength: 4096,
      publicExponent: new Uint8Array([0x01, 0x00, 0x01]),
      hash: { name: "SHA-512" }
    },
    true,
    ["encrypt", "decrypt"]
  );

  const oldKey = app.data.settings[oldIndex];
  const newKey = await window.crypto.subtle.exportKey("jwk", key.publicKey);

  await app.neueEinstellung({
    key: newIndex,
    value: JSON.stringify(newKey),
    securitylevel: oldKey?.securitylevel || 7,
    description: `Public Key von ${newIndex}.key.json`,
    activeFrom: DateTime.utc().toISO()
  });

  // settings are stored as string, even if they contain JSON
  app.data.settings.keys_in_use_public.value =
    app.data.settings.keys_in_use_public.value.replace(oldIndex, newIndex);
  await app.aktualisiereEinstellung(app.data.settings.keys_in_use_public.uuid, {
    value: app.data.settings.keys_in_use_public.value
  });

  await app.aktualisiereEinstellung(oldKey.uuid, {
    activeTo: DateTime.utc().toISO()
  });

  const privateKey = await window.crypto.subtle.exportKey(
    "jwk",
    key.privateKey
  );
  downloadFile(JSON.stringify(privateKey), `${newIndex}.key.json`);

  window.alert(
    `Änderungen erfolgreich durchgeführt. \n\nNach dem Aktualisieren der Seite wird der neue Key fürs verschlüsseln verwendet. \nSobald in allen laufenden Einsätze einmal Patientendaten damit verschlüsselt wurden (1x editieren Diagnose reicht), kann er als aktiv gesetzt werden.`
  );
  window.location.href = app.urls + "/dispo";
  return key;
};
